import { render, staticRenderFns } from "./EditPasswordModal.vue?vue&type=template&id=596b74dc"
import script from "./EditPasswordModal.vue?vue&type=script&lang=js"
export * from "./EditPasswordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports